import { ENABLE_LARGER_PAGE_SIZE_ON_LOGGED_OUT_CATEGORY_240718 } from "@faire/web-api/indigofair/settings/ENABLE_LARGER_PAGE_SIZE_ON_LOGGED_OUT_CATEGORY_240718";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const assignLargerPageSizeOnLoggedOutCategory = () =>
  assignSetting(ENABLE_LARGER_PAGE_SIZE_ON_LOGGED_OUT_CATEGORY_240718);

export const getSettingEnableLargerPageSizeOnLoggedOutCategory = (): boolean =>
  getSettingValueWithoutAssignment(
    ENABLE_LARGER_PAGE_SIZE_ON_LOGGED_OUT_CATEGORY_240718,
    false
  );
